// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"229":"595cf6f7","472":"ac237064","596":"d8f74225","720":"3740e209","896":"49bfe9e6","959":"911eba67"}[chunkId] + ".js";
};